import playersListActions from "./playersListActions";
import {initColumns} from "../../util/Util";

const initialState = {
    order: 'asc',
    orderBy: null,
    page: 0,
    rowsPerPage: 10,
    selectedCategoryId: '',
    categories: [],
    columns: [],
    data: [],
    errorCode: null,
    errorMessage: null
};

function multiplicity(categories, categoryId) {
    let mult = 1;
    categories.forEach((cat) => {
        if (cat.id === categoryId) {
            mult = cat.multiplicity;
        }
    });
    return mult;
}



function handleCategoryLoaded(state, selectedCategoryId, data) {
    const newState = {
        ...state,
        selectedCategoryId: selectedCategoryId,
        data: data,
        page: 0,
        order: 'asc',
        orderBy: null
    };

    const mult = multiplicity(state.categories, selectedCategoryId);
    const columns = initColumns(mult);
    newState.columns = columns;

    return newState;
}

function playersListReducer(state = initialState, action) {
    switch (action.type) {
        case playersListActions.SET_PAGE_SORT:
            return {...state, order: action.order, orderBy: action.orderBy};
        case playersListActions.SET_PAGE_NUMBER:
            return {...state, page: action.page};
        case playersListActions.SET_ROWS_PER_PAGE:
            return {...state, rowsPerPage: action.rowsPerPage};
        case playersListActions.SET_PAGE:
            return {...state, page: action.page, order: action.order, orderBy: action.orderBy};
        case playersListActions.SET_SELECTED_CATEGORY_ID:
            return {...state, selectedCategoryId: action.selectedCategoryId};
        case playersListActions.SET_CATEGORIES:
            return {...state, categories: action.categories};
        case playersListActions.LOAD_CATEGORY_ENTRIES_SUCCESS:
            return handleCategoryLoaded(state, action.selectedCategoryId, action.entries);
            // TODO error messages
        default:
            break;
    }
    return state;
}

export default playersListReducer;